module.exports = __webpack_public_path__ + "static/media/archive.154575eb.svg";